import styled from 'styled-components'

export const FooterContainer = styled.footer`
  background-color: ${(props) => props.theme.azulEscuro};
  padding: 20px;
  text-align: center;
  color: ${(props) => props.theme.azulClaro};
  font-size: 18px;
  border-top: 1px solid ${(props) => props.theme.azulDestaque};
  margin-top: 40px;

  @media (max-width: 600px) {
    font-size: 14px;
    padding: 15px;
    color: ${(props) => props.theme.azulClaro};
    border-top: 1px solid ${(props) => props.theme.azulDestaque};
    margin-top: 30px;
  }
`
